import { LinearProgress, makeStyles, Typography } from "@material-ui/core";
import axios from "axios";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";
import CoinInfo from "../components/CoinInfo";
import { SingleCoin } from "../config/api";
import { numberWithCommas } from "../components/CoinsTable";
import { CryptoState } from "../CryptoContext";
import { useRef } from "react";

const CoinPage = () => {
  const { id } = useParams();
  const [coin,setcoin]=useState('')
  const [price,setprice]=useState('');
  const [data_symbol,set_data_symbol]=useState('')
  const { currency, symbol,check_change_symbol ,coin_data,set_coin_data} = CryptoState();

  // const {context_pair,set_context_pair} = CryptoState();

  const ws = useRef(null);
  let first = useRef(false);


  const fetchCoin = async () => {

    const { data } = await axios.get(SingleCoin(id));
     set_data_symbol(data.symbol)
     set_coin_data(data)
     setcoin(data)
     soket_api(data.symbol)
     console.log('set_coin_data(data)',coin_data,data)
  };

  const soket_api=(props)=>{
    ws.current = new WebSocket("wss://ws-feed.pro.coinbase.com");

     
      let msg = {
        type: "subscribe",
        product_ids: [`${props?.toUpperCase()}-${currency?.toUpperCase()}`],
        channels: ["ticker"]
      };
   
      let jsonMsg = JSON.stringify(msg);

      const check_ready=()=>{
        ws.current.onopen = () =>{
          if (ws.current.readyState === 1) {
            ws.current.send(jsonMsg);
        } 
        else{
          check_ready()
        }
      }
      };
      check_ready()
      ws.current.onmessage = (e) => {
        let data = JSON.parse(e.data);
        if (data.type !== "ticker") {
          return;
        }
  
        if (data.product_id === `${props?.toUpperCase()}-${currency?.toUpperCase()}`) {
          setprice(data.price);
        }
  }  
      
  }
  if(check_change_symbol){
  ws.current = new WebSocket("wss://ws-feed.pro.coinbase.com");
console.log('coin_data22',coin_data)
    let unsubMsg = {
      type: "unsubscribe",
      product_ids: [`${data_symbol.toUpperCase()}-${currency.toUpperCase()}`],
      channels: ["ticker"]
    };
    let unsub = JSON.stringify(unsubMsg);
    const check_ready=()=>{
      ws.current.onopen = () =>{
        if (ws.current.readyState === 1) {
          ws.current.send(unsub)
          soket_api()
      } 
      else{
        check_ready()
      }
    }
    };
    check_ready()


  }

  useEffect(() => {
    fetchCoin();
  }, []);

  


  

  const useStyles = makeStyles((theme) => ({
   
    sidebar: {
      width: "30%",
      minWidth:'400px',
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      marginTop: 25,
      borderRight: "2px solid grey",
    },
    heading: {
      fontWeight: "bold",
      marginBottom: 20,
      fontFamily: "Montserrat",
    },
    description: {
      width: "100%",
      fontFamily: "Montserrat",
      padding: 25,
      paddingBottom: 15,
      paddingTop: 0,
      textAlign: "justify",
    },
    marketData: {
      alignSelf: "start",
      padding: 25,
      paddingTop: 10,
      width: "100%",
      [theme.breakpoints.down("md")]: {
        display: "flex",
        justifyContent: "space-around",
      },
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        alignItems: "center",
      },
      [theme.breakpoints.down("xs")]: {
        alignItems: "start",
      },
    },
  }));

  const classes = useStyles();

  if (!coin) return <LinearProgress style={{ backgroundColor: "gold" }} />;

  return (
    
      <div className={classes.sidebar}>
        <img
          src={coin?.image.large}
          alt={coin?.name}
          height="200"
          style={{ marginBottom: 20 }}
        />
        <Typography variant="h3" className={classes.heading}>
          {coin?.name}
        </Typography>
        <Typography variant="subtitle1" className={classes.description}>
          {ReactHtmlParser(coin?.description.en.split(". ")[0])}.
        </Typography>
        <div className={classes.marketData}>
          <span style={{ display: "flex" }}>
            <Typography variant="h5" className={classes.heading}>
              Rank:
            </Typography>
            &nbsp; &nbsp;
            <Typography
              variant="h5"
              style={{
                fontFamily: "Montserrat",
              }}
            >
              {numberWithCommas(coin?.market_cap_rank)}
            </Typography>
          </span>

          <span style={{ display: "flex" }}>
            <Typography variant="h5" className={classes.heading}>
              Stable Price:
            </Typography>
            &nbsp; &nbsp;
            <Typography
              variant="h5"
              style={{
                fontFamily: "Montserrat",
              }}
            >
              {symbol}{" "}
              {numberWithCommas(
                coin?.market_data.current_price[currency.toLowerCase()]
              )}
            </Typography>
          </span>
          {price?
            <span style={{ display: "flex" }}>
            <Typography variant="h5" className={classes.heading}>
              Current Price:
            </Typography>
            &nbsp; &nbsp;
            <Typography
              variant="h5"
              style={{
                fontFamily: "Montserrat",
              }}
            >
              {symbol}{" "}
              {numberWithCommas(
                price
              )}
            </Typography>
          </span>
        :''}
        
          <span style={{ display: "flex" }}>
            <Typography variant="h5" className={classes.heading}>
              Market Cap:
            </Typography>
            &nbsp; &nbsp;
            <Typography
              variant="h5"
              style={{
                fontFamily: "Montserrat",
              }}
            >
              {symbol}{" "}
              {numberWithCommas(
                coin?.market_data.market_cap[currency.toLowerCase()]
                  .toString()
                  .slice(0, -6)
              )}
              M
            </Typography>
          </span>
        </div>
      </div>

  );
};

export default CoinPage;
